
export enum RequestBuilderActionsEnum {
    EditRequest = "editRequest",
    Purge = "purge"
}